<template>
  <div>  
    <div class="row">
        <div class="col-2">
            <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq" v-model="ppagamento" style="z-index: 999; position: relative;">
                <option value="0">Pagamento previsto</option>
                <option value="1">Efetivo</option>
            </select>
        </div>
        <!-- <div v-show="parseInt(ppagamento)===1" class="col-2">

            <select id="cbcategfor" data-placeholder="Selecione uma categoria" v-model="vidcategfor" data-allow-clear="true" style="z-index: 999; position: relative;">
            </select>
        </div>
        <div class="col-8">
        </div> -->
    </div> 
    <div class="row">
        <div class="col-md-12 grafico-line" style="margin-top: -40px; z-index: 0; position: relative;">
            <template v-if="parseInt(ppagamento)===0">
                <graficoline    :titulo="''"
                                :series="seriesgraficolinepag"
                                :agrupamento="periodograficolinepag"
                                :legendas="legendagraficolinepag"
                ></graficoline>
            </template>
            <template v-else>
                <graficoline    :titulo="''"
                                :series="seriescontaspagar"
                                :agrupamento="periodocontaspagar"
                                :legendas="legendacontaspagar"
                ></graficoline>
            </template>
        </div>
    </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import util from '../../utilitarios/util';
import GraficoLine from '../../components/cmpgraficoline.vue';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "vendascategorias",

  components:{
    'graficoline'		: GraficoLine,
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
       
        margemlucrogeral        : 0,
        showpopover             : false,
        isloading               : false,  
        vtotalservicos          : 0,
        mediafaturamento        : 0,
        usuariologado           : this.$store.state.usuario,

        prevrecebimento       : [],
        seriesgraficoline     : [],
        periodograficoline    : [],
        legendagraficoline    : [],

        ppagamento           : 0,  
        contaspagar          : [],
        seriescontaspagar    : [],
        periodocontaspagar   : [],
        legendacontaspagar   : [],
        vidcategfor          : null,

        ///previsão de pagamento

        prevpagamento        : [],
        seriesgraficolinepag : [],
        periodograficolinepag: [],
        legendagraficolinepag: [],
        

    }
   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
    
  ],
  methods:{
        // defselect2(){
        //     let vself = this;   
        //     $("#cbcategfor").select2({
        //         id: function (e) {return e.id},
        //         ajax: {
        //             url: vself.$store.state.configpaths.pathselect2,
        //             dataType: 'json',
        //             delay: 250,
        //             data: function (params) {
        //                 return {
        //                     q: params.term,
        //                     idclientesac : vself.$store.state.filialpadrao.idcliente,
        //                     tb: 'tbcategorias',
        //                     c1: 'id',
        //                     c2: 'descricao'
        //                 };
        //             },
        //             processResults: function (data) {
        //                 return {
        //                     results: data
        //                 };
        //             },
        //             cache: true
        //         },
        //         minimumInputLength: 0,
        //         theme: 'bootstrap',
        //         language: "pt-BR",
        //         templateResult: util.formatResult,
        //         templateSelection: util.formatSelection
        //     }).change(function () {
        //         vself.vidcategfor = $("#cbcategfor").val();


        //         let filtrocp        = vself.mtdfiltropesquisacp();

        //         let parametros      = [
        //             {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
        //             {parametro: 'op',           valor  : 'executadashcontaspagar'},
        //             {parametro: 'categoria',    valor  : vself.vidcategfor === null ? "" : "AND fr.idcategoria="+vself.vidcategfor},
        //             {parametro: 'filtrocp',     valor  : filtrocp}
        //         ];
        //         let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
        //         retorno.then(function (response) {
        //             vself.mtdprocessadadosgraficolinecontas(response.data.contaspagar)
        //         }).catch(function (response) {
        //             alert('Erro ao consultar registros');
        //         });

        //     });
        // },
        hidepopover(){
          setTimeout(() => {
                    this.showpopover = false;
                }, 200); 
          
        },
        mtdprocessadadosgraficolinepag(data){
            this.prevpagamento    = Object.values(data);
            this.periodograficolinepag = this.mtdobterperiodo(this.prevpagamento);
            
            // Substituir mapeamento do legendagraficoline
            this.legendagraficolinepag = [];
            for (let i = 0; i < this.prevpagamento[0].length; i++) {
            this.legendagraficolinepag.push(this.prevpagamento[0][i].descfil);
            }

            // Substituir mapeamento do seriesgraficoline
            this.seriesgraficolinepag = [];
            for (let i = 0; i < this.prevpagamento[0].length; i++) {
            const filial = this.prevpagamento[0][i];
            const seriesItem = {
                name: filial.descfil,
                type: 'line',
                stack: 'Total',
                data: []
            };

            for (let j = 0; j < this.periodograficolinepag.length; j++) {
                const periodo = this.periodograficolinepag[j];
                const dadosDaFilial = filial.dados.find(item => item.periodo === periodo);
                seriesItem.data.push(dadosDaFilial ? dadosDaFilial.totalcompra : 0);
            }

                    this.seriesgraficolinepag.push(seriesItem);
            }
        },
        mtdformatavalordecimal(valor){
				  return util.formatarvalor(valor, '');
        },
        mtdmediafaturados(){
            let mediafat = 0;

            if(this.lstresumopedidos){
                mediafat = this.lstresumopedidos.totalfaturado / this.lstresumopedidos.qf;
            }
            return mediafat;
        }, 
        mtdmargemlucrogeral() {
          var vself               = this;
      
          const ptotalaberto		  = vself.lstresumopedidos.totalaberto;
          const ptotalfaturado	  = vself.lstresumopedidos.totalfaturado;
          const ptotalcusto 		  = vself.lstresumopedidos.totalcusto;
                
          let totalgeral          = ptotalaberto + ptotalfaturado;

          let dif                 = (parseFloat(totalgeral) - parseFloat(ptotalcusto))

          vself.margemlucrogeral  = 0;
          vself.margemlucrogeral  = dif / totalgeral * 100;
          
        },
        mtdprocessadadosgraficoline(data){
            this.prevrecebimento    = Object.values(data);
            this.periodograficoline = this.mtdobterperiodo(this.prevrecebimento);
            console.log('prevrecebimento', Object.values(data))
            console.log('periodograficoline', this.mtdobterperiodo(this.prevrecebimento))
            // Substituir mapeamento do legendagraficoline
            
            this.legendagraficoline = [];
            for (let i = 0; i < this.prevrecebimento[0].length; i++) {
                this.legendagraficoline.push(this.prevrecebimento[0][i].descfil);
            }

            // Substituir mapeamento do seriesgraficoline
            this.seriesgraficoline = [];
            for (let i = 0; i < this.prevrecebimento[0].length; i++) {
                const filial = this.prevrecebimento[0][i];
                const seriesItem = {
                    name: filial.descfil,
                    type: 'line',
                    stack: 'Total',
                    data: []
                };

                for (let j = 0; j < this.periodograficoline.length; j++) {
                    const periodo = this.periodograficoline[j];
                    const dadosDaFilial = filial.dados.find(item => item.periodo === periodo);
                    seriesItem.data.push(dadosDaFilial ? dadosDaFilial.totalcompra : 0);
                }
                this.seriesgraficoline.push(seriesItem);
            }
            console.log('series:',  this.seriesgraficoline);
            console.log('periodo:', this.periodograficoline);
            console.log('legendas:',this.legendagraficoline);
        },
        mtdobterperiodo(data){
            let arraydata = data[0];
            const periodos = new Set();
            for (let i = 0; i < arraydata.length; i++) {
                const filial = arraydata[i];
                for (let j = 0; j < filial.dados.length; j++) {
                const item = filial.dados[j];
                periodos.add(item.periodo);
                }
            }
            return Array.from(periodos);
        },
        mtdexecutadash(){
            var vself           = this;       
            vself.$emit('handlerLoader', true);      
            let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
            // let filtro          = vself.mtdfiltropesquisa();
            // let filtrocp        = vself.mtdfiltropesquisacp();
            let parametros      = [
                {parametro: 'idclientesac', valor  : window.localStorage.getItem('idcliente')},
                {parametro: 'op',           valor  : 'dashboard'},
                {parametro: 'periodo',      valor   : periodo},
                {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
                // {parametro: 'filtro',       valor  : filtro},
                // {parametro: 'filtrocp',     valor  : filtrocp},
                // {parametro: 'dini',         valor  : util.InverterData(vself.pdtini)},
                // {parametro: 'dfim',         valor  : util.InverterData(vself.pdtfim)}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
            retorno.then(function (response) {
                

                // vself.dadossetorpro     = response.data.setorpro;
                // vself.legendassetorpro  = util.gerardadoslegendagrafico(vself.dadossetorpro);

                // vself.dadosgrupospro    = response.data.grupopro;
                // vself.legendasgrupospro = util.gerardadoslegendagrafico(vself.dadosgrupospro);

                // vself.dadospedidosfil   = response.data.comprasfil;
                // vself.legendaspedidofil = util.gerardadoslegendagrafico(vself.dadospedidosfil);

                // vself.dadosmarca        = response.data.comprasmarca;
                // vself.legendasmarca     = util.gerardadoslegendagrafico(vself.dadosmarca);

        
                // vself.dadosmeta = [
                //     {value: parseFloat(response.data.atingida), name: 'ATINGIDA'},
                //     {value: parseFloat(response.data.restante), name: 'RESTANTE'}                       
                    
                // ];
                // vself.legendasmeta = util.gerardadoslegendagrafico(vself.legendasmeta);
                vself.mtdprocessadadosgraficoline(response.data.prevrecebimento);
                console.log("daodsodkasod:", vself.mtdprocessadadosgraficoline(response.data.prevrecebimento));
                vself.mtdprocessadadosgraficolinepag(response.data.prevpagamento);
                vself.mtdprocessadadosgraficolinecontas(response.data.contaspagar)
                vself.$emit('handlerLoader', false);
            }).catch(function (response) {
                vself.$emit('handlerLoader', false);
            });
        },
        mtdprocessadadosgraficolinecontas(data){
            this.compraspagar          = Object.values(data);
            this.periodocontaspagar    = this.mtdobterperiodo(this.compraspagar);
            
            // Substituir mapeamento do legendagraficoline
            this.legendacontaspagar    = [];
            for (let i = 0; i < this.compraspagar[0].length; i++) {
                this.legendacontaspagar.push(this.compraspagar[0][i].descfil);
            }

            // Substituir mapeamento do seriesgraficoline
            this.seriescontaspagar     = [];
            for (let i = 0; i < this.compraspagar[0].length; i++) {
            const filial = this.compraspagar[0][i];
            const seriesItem = {
                name: filial.descfil,
                type: 'line',
                stack: 'Total',
                data: []
            };

            for (let j = 0; j < this.periodocontaspagar.length; j++) {
                const periodo = this.periodocontaspagar[j];
                const dadosDaFilial = filial.dados.find(item => item.periodo === periodo);
                seriesItem.data.push(dadosDaFilial ? dadosDaFilial.totalcompra : 0);
            }

                    this.seriescontaspagar.push(seriesItem);
            }
        },
  },
  mounted(){


    setTimeout(() => {
         this.mtdexecutadash();
        //  this.defselect2();
    }, 3000);
   
  },
  computed:{
            
  },
}
</script>
